/**
 * 成本看板（S6）的文案。命名空间 `visualGameAdmin.llm.cost.*`。
 *
 * `en` 与 `zh` 的 key 集必须逐字相同 —— `test/i18n.test.js` 拍平后逐项比对六个语种
 * （`ja`/`es`/`id`/`pt` 是 `structuredClone(en)` 的桩，自动跟随）。
 *
 * **这里不放说明性文字。** 页面上任何一段超过 20 字的解释都是给写代码的人看的，它们的位置在
 * `plan/llm-admin/`，不在运营的屏幕上（版式规范第一条）。「成本是怎么算出来的」「未计价的调用为什么
 * 不进合计」「区间为什么按 UTC」都已经从这里删掉了。
 */

export const en = {
  title: 'Cost',
  retry: 'Retry',
  allCalls: 'All calls',

  filter: {
    since: 'From',
    until: 'To',
    recent: 'Last {days}d',
    preset: 'Range',
    refresh: 'Refresh',
    utcHint: 'UTC days',
  },

  card: {
    calls: 'Calls',
    cost: 'Total cost',
    chargedPoints: 'Charged points',
    recordOnlyCalls: 'Record-only calls',
    failureRate: 'Failure rate',
    failedCalls: 'Failed',
  },

  unpriced: {
    badge: 'Cost pending',
    short: '{count} cost pending',
  },

  bucket: {
    day: 'By day',
    hour: 'By hour',
  },

  metric: {
    cost: 'Cost',
    supplier_cost_micros: 'Supplier cost',
    calls: 'Calls',
    charged_points: 'Charged points',
  },

  chart: {
    bucketLabel: 'Bucket',
    metricLabel: 'Metric',
    timeTitle: 'Over time',
    clickToZoom: 'View this time range',
    clickToCalls: 'View call details',
  },

  analysis: {
    title: 'Cost breakdown',
    capability: 'Model capability',
    billing: 'Billing mode',
    model: 'Model',
    user: 'User',
  },

  tabs: {
    model: 'By model',
    user: 'By user',
  },

  table: {
    title: 'Breakdown',
    model: 'Capability / model',
    user: 'User',
    cost: 'Cost',
    calls: 'Calls',
    chargedPoints: 'Points',
    recordOnly: 'Record only',
    failed: 'Failed',
    failureRate: 'Fail %',
    unpriced: 'Cost pending',
    drill: 'Call log',
    drillAction: 'Open',
  },

  user: {
    anonymous: '(no user)',
    noDrilldown: 'No drill-down',
  },

  empty: {
    title: 'No calls in this range',
    action: 'Look at the last 30 days',
  },
}

export const zh = {
  title: '成本',
  retry: '重试',
  allCalls: '全部调用',

  filter: {
    since: '起始日',
    until: '截止日',
    recent: '最近 {days} 天',
    preset: '区间',
    refresh: '刷新',
    utcHint: '按 UTC 天',
  },

  card: {
    calls: '总调用数',
    cost: '总成本',
    chargedPoints: '已扣积分',
    recordOnlyCalls: '仅记录调用',
    failureRate: '失败率',
    failedCalls: '失败',
  },

  unpriced: {
    badge: '成本待核算',
    short: '{count} 条成本待核算',
  },

  bucket: {
    day: '按天',
    hour: '按小时',
  },

  metric: {
    cost: '成本',
    supplier_cost_micros: '供应商成本',
    calls: '调用数',
    charged_points: '扣除积分',
  },

  chart: {
    bucketLabel: '粒度',
    metricLabel: '看哪个数',
    timeTitle: '时间趋势',
    clickToZoom: '查看该时间段',
    clickToCalls: '查看调用明细',
  },

  analysis: {
    title: '成本构成',
    capability: '模型能力',
    billing: '计费方式',
    model: '模型',
    user: '用户',
  },

  tabs: {
    model: '按模型',
    user: '按用户',
  },

  table: {
    title: '明细',
    model: '能力 / 模型',
    user: '用户',
    cost: '成本',
    calls: '调用数',
    chargedPoints: '扣除积分',
    recordOnly: '仅记录',
    failed: '失败',
    failureRate: '失败率',
    unpriced: '成本待核算',
    drill: '调用日志',
    drillAction: '查看',
  },

  user: {
    anonymous: '（无用户归属）',
    noDrilldown: '无用户归属',
  },

  empty: {
    title: '这段区间里没有调用',
    action: '切换到最近 30 天',
  },
}
